import axios, {
  AxiosInstance,
  AxiosError,
  AxiosResponse,
} from 'axios';
import https from 'https';

// This loggiing config sucks but it works for now
import logger from '../logging';

interface DrugExceptionsClientInterface {
  api: AxiosInstance;
}

export class DrugExceptionsClient implements DrugExceptionsClientInterface {
  api!: AxiosInstance;

  constructor() {
    this.initXhrInstances();
  }

  private initXhrInstances() {
    this.api = axios.create({ baseURL: process.env.REACT_APP_API_URL,
                              httpsAgent: new https.Agent ({
                                rejectUnauthorized: false,
                              })
    });
 
    this.api.interceptors.response.use(
      this.responseHandler,
      this.responseErrorHandler
    );
  }

  private responseHandler(response: AxiosResponse): any {
    return response;
  }

  private responseErrorHandler(error: AxiosError): any {
    if (error.response !== undefined) {
      logger.debug(
        `Error Message: ${JSON.stringify((error.response as any).data)}`
      );
      logger.debug(
        `RequestID: ${(error.response as any).headers['x-request-id']}`
      );

      if (error.response.status === 401) {
        logger.error('Did you forget to set token?');
      }
    } else {
      logger.debug(`ERROR: ${error.message}`);
    }

    return Promise.reject(error);
  }
}
